const BASE62_CHARS =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

export function uuidToBase62(uuid) {
  const hex = uuid.replace(/-/g, '');
  let num = BigInt('0x' + hex);
  if (num === 0n) return '0';
  let result = '';
  while (num > 0n) {
    result = BASE62_CHARS[num % 62n] + result;
    num = num / 62n;
  }
  return result;
}
